import { render, staticRenderFns } from "./RegisterFormExcerpt.vue?vue&type=template&id=5d406c2c&scoped=true"
import script from "./RegisterFormExcerpt.vue?vue&type=script&lang=js"
export * from "./RegisterFormExcerpt.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormExcerpt.vue?vue&type=style&index=0&id=5d406c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d406c2c",
  null
  
)

export default component.exports